import { JsonSerializable } from '@/util/object/JsonSerializable'

export class RecipientInfoResponse extends JsonSerializable {
  /** @type {Date} */
  #firstRedemptionOccurredAt
  /** @type {Date} */
  #lastRedemptionOccurredAt
  /** @type {number} */
  #countOfTotalRedemptions
  /** @type {number} */
  #countOfRedemptionsSinceConfiguredCutoff

  constructor (jsonObject) {
    super()
    this.#firstRedemptionOccurredAt = new Date(jsonObject.firstRedemptionOccurredAt || undefined)
    this.#lastRedemptionOccurredAt = new Date(jsonObject.lastRedemptionOccurredAt || undefined)
    this.#countOfTotalRedemptions = Number.parseInt(jsonObject.countOfTotalRedemptions) || undefined
    this.#countOfRedemptionsSinceConfiguredCutoff = Number.parseInt(jsonObject.countOfRedemptionsSinceConfiguredCutoff) || undefined
    Object.freeze(this)
  }

  get firstRedemptionOccurredAt () {
    return this.#firstRedemptionOccurredAt
  }

  get lastRedemptionOccurredAt () {
    return this.#lastRedemptionOccurredAt
  }

  get countOfTotalRedemptions () {
    return this.#countOfTotalRedemptions
  }

  get countOfRedemptionsSinceConfiguredCutoff () {
    return this.#countOfRedemptionsSinceConfiguredCutoff
  }

  /**
   * @return {Object}
   */
  toJSON () {
    return {
      redemptionCounts: {
        firstRedemptionOccurredAt: this.#firstRedemptionOccurredAt?.valueOf() || undefined,
        lastRedemptionOccurredAt: this.#lastRedemptionOccurredAt?.valueOf() || undefined,
        countOfTotalRedemptions: this.#countOfTotalRedemptions,
        countOfRedemptionsSinceConfiguredCutoff: this.#countOfRedemptionsSinceConfiguredCutoff
      }
    }
  }

  /**
   * @param {Object} jsonObject
   * @return {RecipientInfoResponse|undefined}
   */
  static fromJSON (jsonObject) {
    return (jsonObject && new RecipientInfoResponse(jsonObject?.redemptionCounts)) || undefined
  }
}
